// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ng/styles/" + chunkId + "-" + {"11":"08a8f9c83b58e922f904","706":"f909a96a6a626a659313","856":"daf35ee5fd8a9f7c4961"}[chunkId] + ".css";
};